import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { HouseDrawing } from "./Blueprint";
import { EASE } from "./motion";

const KEY = "carvings-drafted";

export const Preloader = () => {
  const [show, setShow] = useState(() => typeof window !== "undefined" && !sessionStorage.getItem(KEY));
  const [pct, setPct] = useState(0);

  useEffect(() => {
    if (!show) return;
    document.documentElement.style.overflow = "hidden";
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min(100, Math.round(((now - start) / 2000) * 100));
      setPct(p);
      if (p < 100) requestAnimationFrame(tick);
      else setTimeout(() => { sessionStorage.setItem(KEY, "1"); setShow(false); }, 250);
    };
    const raf = requestAnimationFrame(tick);
    return () => { cancelAnimationFrame(raf); document.documentElement.style.overflow = ""; };
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 z-[100] bg-[#161614] text-[#C29B38] flex flex-col items-center justify-center px-8"
          exit={{ clipPath: "inset(0 0 100% 0)" }}
          transition={{ duration: 0.9, ease: EASE }}
          data-testid="preloader"
        >
          <HouseDrawing className="w-full max-w-md" duration={1.6} />
          <div className="mt-8 flex items-center gap-4 font-mono text-[11px] uppercase tracking-[0.3em] text-stone-400">
            <span>Drafting</span>
            <span className="h-px w-16 bg-stone-700 overflow-hidden"><motion.span className="block h-full bg-[#C29B38]" style={{ width: `${pct}%` }} /></span>
            <span className="tabular-nums text-[#FBFBF9]" data-testid="preloader-pct">{pct}%</span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
